import apiClient from '../apiClient';

const baseUrl = '/ai/gpt/simple';

export type GptItem = {
  _id?: string;
  message: string;
  history: { role: 'user' | 'assistant'; content: string }[];
};

/** 分页列表 */
export async function queryUserList(params: {
  current?: number;
  pageSize?: number;
  username?: string;
  roleCode?: string;
}) {
  return apiClient<{
    list: GptItem[];
    total: number;
  }>(baseUrl, {
    method: 'GET',
    params,
  });
}

/** 使用gpt */
export async function getGptData(data: GptItem) {
  return apiClient<{ code: number; reply: any }>(baseUrl, {
    method: 'POST',
    data,
  });
}
